import React from 'react';
import { Avatar } from '@odin-labs/components';
import { getInitialsForUser } from 'utils';
import { Announcement } from 'containers/announcements/types';
import { AnnouncementInput } from './constants';

export function AnnouncementSentBy(
  props: AnnouncementInput,
): React.ReactElement {
  const { announcement } = props as { announcement: Announcement };
  const { sentBy } = announcement;
  if (sentBy) {
    const { identity } = sentBy;
    const { firstName, lastName } = identity;
    const name = [firstName, lastName].join(' ') ?? 'Unknown';
    const url = sentBy?.profilePictureCropped?.downloadUrl;

    return (
      <div className="odin-flex odin-row">
        <Avatar
          placeholder={getInitialsForUser(sentBy)}
          objectFit="cover"
          src={url}
          size="sm"
        />
        <div className="odin-ml-1">{name}</div>
      </div>
    );
  }
  return <div />; // use a div as placeholder to preserve the layout
}
